import React from "react";

export default function RightPanel() {
  return <div className="signup-right-wrapper"></div>;
}
